module.exports = __webpack_public_path__ + "34481df7bef69bdc0cd06c2c62348cc8.png";